"use client";

import { Footer } from "@/components/footer";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { Saas } from "@/components/page/saas/assa";
import { PainPoints } from "@/components/page/saas/painPoints";
import { Principle } from "@/components/page/saas/principle";
import { Advantages } from "@/components/page/saas/advantages";
import { Scenarios } from "@/components/page/saas/scenarios";
import { useIsMobile } from "../hooks/useIsMobile";
import { SaasMobileFirst } from "@/components/page/saas-mobile/first";
import { SaasMobileFourth } from "@/components/page/saas-mobile/fourth";
import { MobileFooter } from "@/components/mobile-footer";
import { HeaderMobile } from "@/components/header-mobile";
import { SaasMobileFiveth } from "@/components/page/saas-mobile/fiveth";
import { SaasMobileSecond } from "@/components/page/saas-mobile/second";

export default function SaasPageClient() {
  const isMobile = useIsMobile();

  if (isMobile === null)
    return (
      <div
        className="w-screen h-screen"
        style={{ background: "linear-gradient(135deg, rgba(236,245,255,1) 2.885%, rgba(185,242,250,1) 56.731%, rgba(110,201,255,1) 97.596%)" }}
      />
    );

  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-screen overflow-y-auto">
        <HeaderMobile />
        <SaasMobileFirst />
        <SaasMobileSecond />
        <SaasMobileFourth />
        <SaasMobileFiveth />
        <MobileFooter />
      </div>
    );
  }
  return (
    <AutofitPageWrapper>
      <Saas />
      <PainPoints />
      <Principle />
      <Advantages />
      <Scenarios />
      <Footer />
    </AutofitPageWrapper>
  );
}
